'use client'
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/FixedBar/FixedBar.tsx
import { twMerge } from "tailwind-merge";

// src/FixedBar/FixedBar.classes.tsx
var POSITION_CSS = {
  top: "top-0 safe-top",
  bottom: "bottom-0 safe-bottom"
};

// src/FixedBar/FixedBar.tsx
import { jsx } from "react/jsx-runtime";
var FixedBar = (_a) => {
  var _b = _a, { position = "bottom", className, children } = _b, props = __objRest(_b, ["position", "className", "children"]);
  return /* @__PURE__ */ jsx(
    "div",
    __spreadProps(__spreadValues({
      className: twMerge("fixed inset-x-0 z-40 w-full", POSITION_CSS[position], className)
    }, props), {
      children
    })
  );
};
var FixedBar_default = FixedBar;

export {
  FixedBar_default
};
//# sourceMappingURL=chunk-KGA7I22W.mjs.map